export function buildAccessProperties(username, currentAccessProperties, accessChangeset) {
    return accessChangeset.reduce((accessProperties, accessChange) => {
        const { action, targetProperty } = accessChange;
        if (action === 'add') {
            accessProperties[targetProperty] = {
                updatedAt: new Date(),
                updatedBy: username,
            };
        }
        else if (action === 'remove') {
            delete accessProperties[targetProperty];
        }
        return accessProperties;
    }, currentAccessProperties);
}
//# sourceMappingURL=build-access-properties.js.map